import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { mediaQueries } from '@zapier/identity-utils';

type FeatureItemListProps = {
  children: ReactNode;
};

const listStyles = css`
  display: none;

  ${mediaQueries.tablet} {
    display: grid;
    gap: 20px;
  }

  ${mediaQueries.desktop} {
    gap: 10px;
  }
`;

export function FeatureItemList({ children }: FeatureItemListProps) {
  return <ul css={[listStyles]}>{children}</ul>;
}
